function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.57,
    height: 20,
    viewBox: "0 0 19.57 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.832 8.469 32.117 0h-1.726l-6.326 7.353L19.012 0h-5.827l7.64 11.119L13.185 20h1.726l6.68-7.765L26.928 20h5.827L24.831 8.469zm-2.365 2.749-.774-1.107L15.534 1.3h2.652l4.971 7.11.774 1.107 6.461 9.242H27.74l-5.273-7.542z",
    transform: "translate(-13.185)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5f336d74f974a9da0cbdd19ab17009e8.svg";
export { ForwardRef as ReactComponent };